<app-modal title="Dados Cadastrais" class="density-lower"
[buttons]="true">
<div class="modal-content">
  <div class="center" *ngIf="loading">
    <span> Carregando Dados Cadastratis  </span>
    <mat-spinner diameter="30"></mat-spinner>
  </div>

  <div *ngIf="!loading">

    <section class="flex-row-split">
      <span class="field">
      <label class="field-label"> Nome do Cliente </label>
      <span class="field-data" data-cy="clientName">{{ client.personName }}</span>
    </span>

    <span class="field">
      <label class="field-label"> Endereço </label>
      <span class="field-data" data-cy="address">{{ client?.address ?? "Dado não existente" }}</span>
    </span>
  </section>

  <section class="flex-row-split">
    <span class="field">
      <label class="field-label"> Telefone </label>
      <span class="field-data" data-cy="phone">{{ client.phone }}</span>
    </span>

    <span class="field">
      <label class="field-label"> Email </label>
      <span class="field-data" data-cy="email">{{ client?.email ?? "Dado não existente" }}</span>
    </span>
  </section>
</div>

</div>
</app-modal>
